<template>
  <div class="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <p class="text-xs font-medium text-slate-500">{{ title }}</p>
        <p class="mt-2 truncate text-2xl font-semibold text-slate-900">{{ value }}</p>
      </div>
      <div class="flex h-9 w-9 items-center justify-center rounded-lg" :class="toneClass">
        <slot name="icon">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 19h16M7 16V8m5 8V5m5 11v-6"/>
          </svg>
        </slot>
      </div>
    </div>
    <p v-if="description" class="mt-3 truncate text-xs text-slate-500">{{ description }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number],
    default: '--'
  },
  description: {
    type: String,
    default: ''
  },
  tone: {
    type: String,
    default: 'primary'
  }
})

const toneClass = computed(() => {
  const map = {
    primary: 'bg-primary-50 text-primary-600',
    emerald: 'bg-emerald-50 text-emerald-600',
    amber: 'bg-amber-50 text-amber-600',
    red: 'bg-red-50 text-red-600',
    indigo: 'bg-indigo-50 text-indigo-600',
    slate: 'bg-slate-100 text-slate-600'
  }
  return map[props.tone] || map.primary
})
</script>
